import { panesData } from "@/types";

export const paneData: panesData[] = [
  {
    className: "hero-box__circle--blue",
    title: "Publish",
    firstLine: "Lorem ipsum dolor sit amet, consectetur elit.",
    secondLine: "Vestibulum arcu pellentesque."
  },
  {
    className: "hero-box__circle--green",
    title: "Sell",
    firstLine: "Vestibulum mattis nec dui a dapibus.",
    secondLine: "Nunc eget vehicula."
  },
  {
    className: "hero-box__circle--orange",
    title: "Exchange ideas",
    firstLine: "Quisque mattis semper purus.",
    secondLine: "fermentum ornare nulla."
  }
];
